import template from './index.html';

export default ['footerBar', function () {
    'ngInject';

    return {
        restrict: 'AEC',
        template: template,
        scope: {},
        link: function (scope, element) {
            element;
        }
    };
}];



// WEBPACK FOOTER //
// ./src/app/directives/footer/index.js